import React from "react";
export default function PriceArea() {
  return (
    <div className="w-full ">
      <div className="flex border-y border-l border-brand-blue-50 rounded-tl-[24px] rounded-bl-[24px] -mr-2">
        <div className="w-[125px] sm:w-[235px] border-r  shrink-0 divide-y divide-brand-blue-50">
          <div className="h-72 pt-6 px-6">
            <div className=" rounded bg-brand-gray-100 h-6 shadow-inner w-[122px] animate-pulse"></div>
          </div>
          <div className="h-20 flex flex-col justify-center sm:flex-row sm:justify-between px-5 sm:items-center ">
            <div className=" rounded bg-brand-gray-100 h-6 shadow-inner w-[90px] animate-pulse"></div>
            <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
          </div>
          <div className="h-20 flex flex-col justify-center sm:flex-row sm:justify-between px-5 sm:items-center ">
            <div className=" rounded bg-brand-gray-100 h-6 shadow-inner w-[90px] animate-pulse"></div>
            <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
          </div>
          <div className="h-20 flex flex-col justify-center sm:flex-row sm:justify-between px-5 sm:items-center ">
            <div className=" rounded bg-brand-gray-100 h-6 shadow-inner w-[90px] animate-pulse"></div>
            <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
          </div>
        </div>
        <div className="overflow-x-auto hide-scroll w-full">
          <div className="flex divide-x divide-brand-blue-50 ">
            <div className="divide-y divide-brand-blue-50 shrink-0 last:!border-r border-brand-blue-50 ">
              <div className="shrink-0 h-72 divide-y divide-brand-blue-50">
                <div className="px-4 md:px-6 pt-6 pb-4 space-y-3">
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-6 animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                </div>
                <div className="px-4 md:px-6 py-4 space-y-2">
                  <div className=" rounded bg-brand-gray-100 h-6 shadow-inner w-[110px] animate-pulse"></div>
                  <ul className="grid gap-2">
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
            </div>
            <div className="divide-y divide-brand-blue-50 shrink-0 last:!border-r border-brand-blue-50 ">
              <div className="shrink-0 h-72 divide-y divide-brand-blue-50">
                <div className="px-4 md:px-6 pt-6 pb-4 space-y-3">
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-6 animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                </div>
                <div className="px-4 md:px-6 py-4 space-y-2">
                  <div className=" rounded bg-brand-gray-100 h-6 shadow-inner w-[110px] animate-pulse"></div>
                  <ul className="grid gap-2">
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
            </div>
            <div className="divide-y divide-brand-blue-50 shrink-0 last:!border-r border-brand-blue-50 ">
              <div className="shrink-0 h-72 divide-y divide-brand-blue-50">
                <div className="px-4 md:px-6 pt-6 pb-4 space-y-3">
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-6 animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                </div>
                <div className="px-4 md:px-6 py-4 space-y-2">
                  <div className=" rounded bg-brand-gray-100 h-6 shadow-inner w-[110px] animate-pulse"></div>
                  <ul className="grid gap-2">
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
            </div>
            <div className="divide-y divide-brand-blue-50 shrink-0 last:!border-r border-brand-blue-50 ">
              <div className="shrink-0 h-72 divide-y divide-brand-blue-50">
                <div className="px-4 md:px-6 pt-6 pb-4 space-y-3">
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-6 animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                </div>
                <div className="px-4 md:px-6 py-4 space-y-2">
                  <div className=" rounded bg-brand-gray-100 h-6 shadow-inner w-[110px] animate-pulse"></div>
                  <ul className="grid gap-2">
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
            </div>
            <div className="divide-y divide-brand-blue-50 shrink-0 last:!border-r border-brand-blue-50 ">
              <div className="shrink-0 h-72 divide-y divide-brand-blue-50">
                <div className="px-4 md:px-6 pt-6 pb-4 space-y-3">
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-6 animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                </div>
                <div className="px-4 md:px-6 py-4 space-y-2">
                  <div className=" rounded bg-brand-gray-100 h-6 shadow-inner w-[110px] animate-pulse"></div>
                  <ul className="grid gap-2">
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
            </div>
            <div className="divide-y divide-brand-blue-50 shrink-0 last:!border-r border-brand-blue-50 ">
              <div className="shrink-0 h-72 divide-y divide-brand-blue-50">
                <div className="px-4 md:px-6 pt-6 pb-4 space-y-3">
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-6 animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                  <div className=" rounded bg-brand-gray-light h-6 shadow-inner w-full animate-pulse"></div>
                </div>
                <div className="px-4 md:px-6 py-4 space-y-2">
                  <div className=" rounded bg-brand-gray-100 h-6 shadow-inner w-[110px] animate-pulse"></div>
                  <ul className="grid gap-2">
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                    <li className="flex gap-3 items-start">
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-6 shrink-0 animate-pulse"></div>
                      <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-full animate-pulse"></div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
              <div className="flex items-center gap-20 h-20 px-6">
                <div className=" rounded bg-brand-gray-100 h-[37px] shadow-inner w-[90px] animate-pulse"></div>
                <div className=" rounded bg-brand-gray-50 h-6 shadow-inner w-[52px] animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
